import { useState } from 'react'
import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldHyperlink({ field, action, value, handleChange, hasChanged }) {
  console.log(`AppObjectFieldHyperlink rendered: ${field.name}`)

  const [text, setText] = useState(value)

  function handleTextChange(event) {
    setText(event.target.value)
    handleChange(event, hasChanged)
  }

  const disabled = isDisabled(action, field.behaviorType)
  if (disabled) {
    let url = value
    if (value.indexOf('://') === -1) {
      url = `http://${value}`
    }
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {value}
      </a>
    )
  } else {
    return (
      <Input
        type="text"
        name={field.id}
        bsSize="sm"
        id={field.id}
        value={text}
        onChange={(event) => handleTextChange(event, hasChanged)}
        size={field.width.toString()}
      />
    )
  }
}
